module.exports = {
	"name": "musbi-frontend",
	"version": "3.0.5",
	"description": "Musbi Frontend",
	"scripts": {
		"start": "export $(grep '^#' .dev.env -v | xargs) && node bin/server.js",
		"dev": "export $(grep '^#' .dev-docker.env -v | xargs) && node bin/server.js",
		"prepreview": "npm run build:preview",
		"preview": "npm run preview",
		"preview:frontend": "http-server -p 4005 dist/",
		"preview:backend": "http-server -p 4005 dist/backend/",
		"preview-only": "npm run preview:frontend",
		"svgstore": "DEBUG=app:* FRONTEND_URL=/ node bin/svgstore.js",
		"build": "npm run build:live",
		"build:preview": "DEBUG=app:* BUILD_ENV=preview node bin/build.js",
		"postbuild:preview": "BUILD_ENV=preview scripts/apply-config.sh",
		"build:staging": "DEBUG=app:* BUILD_ENV=staging node bin/build.js",
		"postbuild:staging": "BUILD_ENV=staging scripts/apply-config.sh",
		"build:live": "DEBUG=app:* BUILD_ENV=live node bin/build.js",
		"postbuild:live": "BUILD_ENV=live scripts/apply-config.sh",
		"build:mittwald": "DEBUG=app:* BUILD_ENV=mittwald node bin/build.js",
		"postbuild:mittwald": "BUILD_ENV=mittwald scripts/apply-config.sh",
		"test": "jest --config ./jest.config.js --coverage",
		"test:no-cover": "jest --config ./jest.config.js",
		"test:dev": "jest --config ./jest.config.js --coverage --watch",
		"test:dev:no-cover": "jest --config ./jest.config.js --watch",
		"test:debug": "node --inspect node_modules/.bin/jest --runInBand --no-cache --config ./jest.config.js --watch",
		"lint": "eslint ./src",
		"lint:fix": "eslint --fix ./src"
	},
	"keywords": [
		"react",
		"mobx"
	],
	"author": "Simon Schmidt",
	"license": "MIT",
	"devDependencies": {
		"ajv": "6.2.0",
		"babel-core": "6.11.4",
		"babel-eslint": "8.2.6",
		"babel-jest": "12.1.0",
		"babel-loader": "6.2.8",
		"babel-plugin-add-module-exports": "0.2.1",
		"babel-plugin-array-includes": "2.0.3",
		"babel-plugin-transform-decorators-legacy": "1.3.4",
		"babel-plugin-transform-object-assign": "6.8.0",
		"babel-plugin-transform-object-rest-spread": "6.8.0",
		"babel-plugin-transform-react-constant-elements": "6.9.1",
		"babel-plugin-transform-react-display-name": "6.8.0",
		"babel-plugin-transform-react-inline-elements": "6.8.0",
		"babel-plugin-transform-react-remove-prop-types": "0.2.11",
		"babel-plugin-transform-runtime": "6.15.0",
		"babel-preset-es2015": "6.18.0",
		"babel-preset-es2015-loose": "7.0.0",
		"babel-preset-react": "6.16.0",
		"babel-preset-stage-0": "6.16.0",
		"babel-preset-stage-1": "6.16.0",
		"babel-register": "6.8.0",
		"chai": "3.5.0",
		"clean-webpack-plugin": "0.1.14",
		"css-loader": "0.23.1",
		"dotenv": "^16.3.1",
		"enzyme": "2.6.0",
		"eslint": "4.19.1",
		"eslint-config-airbnb": "16.1.0",
		"eslint-config-prettier": "6.9.0",
		"eslint-loader": "1.9.0",
		"eslint-plugin-import": "2.14.0",
		"eslint-plugin-jsx-a11y": "6.1.2",
		"eslint-plugin-prettier": "3.1.2",
		"eslint-plugin-react": "7.11.1",
		"extract-text-webpack-plugin": "1.0.1",
		"file-loader": "0.9.0",
		"fs-extra": "2.1.2",
		"html-replace-webpack-plugin": "2.2.4",
		"html-webpack-plugin": "2.28.0",
		"http-server": "^14.1.1",
		"image-webpack-loader": "2.0.0",
		"jest": "24.9.0",
		"jsdom": "9.8.3",
		"jshint": "2.9.4",
		"json-loader": "0.5.4",
		"less": "2.7.1",
		"less-loader": "2.2.3",
		"less-plugin-autoprefix": "1.5.1",
		"less-plugin-clean-css": "1.5.1",
		"mocha": "3.1.2",
		"node-sass": "^6.0.1",
		"prettier": "1.19.1",
		"react-a11y": "0.3.3",
		"react-addons-test-utils": "15.4.0",
		"react-hot-loader": "3.0.0-beta.6",
		"redbox-react": "1.3.0",
		"rimraf": "2.6.1",
		"sass-loader": "4.1.1",
		"should": "11.1.1",
		"style-loader": "0.13.1",
		"svgstore": "2.0.2",
		"webpack": "1.14.0",
		"webpack-dev-server": "1.16.2",
		"why-did-you-update": "0.0.8"
	},
	"dependencies": {
		"babel-polyfill": "6.16.0",
		"classnames": "2.2.5",
		"core-decorators": "0.14.0",
		"debug": "3.0.0",
		"lodash": "4.17.4",
		"mobx": "2.6.3",
		"mobx-react": "3.5.9",
		"mobx-react-devtools": "4.2.10",
		"mobx-remotedev": "0.1.3",
		"moment": "2.17.1",
		"node-uuid": "1.4.7",
		"prop-types": "15.6.1",
		"rc-slider": "7.0.2",
		"react": "15.6.2",
		"react-addons-shallow-compare": "15.6.2",
		"react-dom": "15.6.2",
		"react-google-maps": "6.3.0",
		"react-google-static-map": "github:viatsko/react-google-static-map",
		"react-router": "2.8.1",
		"react-spinkit": "1.1.11",
		"react-tooltip": "3.3.0",
		"react-trigger-change": "1.0.2",
		"reactify": "1.1.1",
		"superagent": "2.3.0"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 1504
// module chunks = 0